import type { ConfirmacaoDialogProps } from "./types-confirmacao-dialog";

/** Separa a última frase (a pergunta) do contexto que a antecede. */
function separarPergunta(message: string) {
  const corte = message.lastIndexOf(". ");
  if (corte < 0) return { pergunta: message, contexto: undefined };
  return { contexto: message.slice(0, corte + 1), pergunta: message.slice(corte + 2) };
}

export function useConfirmacaoDialog({ message, accept, onHide, testId }: ConfirmacaoDialogProps) {
  const { pergunta, contexto } = separarPergunta(message);

  return {
    pergunta,
    contexto,
    confirmar: () => {
      accept();
      onHide();
    },
    dialogTestId: `${testId}-dialog`,
    cancelarTestId: `${testId}-cancel`,
    confirmarTestId: `${testId}-confirm`,
  };
}
